import React from 'react';
import { FiRefreshCw, FiDatabase, FiClock, FiImage } from 'react-icons/fi';
import DashboardCardGrid from '../components/DashboardCardGrid';

export const GLOBAL_SETTINGS_CARD_DATA = [
  {
    title: 'Update Version',
    description: 'Update the app version.',
    path: '/update-Version',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiRefreshCw size={28} />,
    accent: '#0ea5e9',
  },
  {
    title: 'Update Metadata',
    description: 'Update metadata globally.',
    path: '/metadata-Change',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiDatabase size={28} />,
    accent: '#8b5cf6',
  },
  {
    title: 'Disinfection Time',
    description: 'Get an update disinfection time.',
    path: '/disinfectionTime',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiClock size={28} />,
    accent: '#06b6d4',
  },
  {
    title: 'Robot Model Image',
    description: 'View and upload robot model images.',
    path: '/Viewimage',
    roles: ['Hr', 'ProjectManager', 'AdminController'],
    icon: <FiImage size={28} />,
    accent: '#0d9488',
  },
];

export default function CardGridDashboard() {
  return (
    <DashboardCardGrid
      pageTitle="Global Settings"
      pageSubtitle="Version, metadata, disinfection time, and image management"
      cardData={GLOBAL_SETTINGS_CARD_DATA}
    />
  );
}
